import { atom } from 'jotai';

export const feedbackOpenAtom = atom<boolean>(false);
